/** Общий образец отказа по правам — тот же, что в приложении и на сервере БЭМ. */
export const NO_RIGHTS_TEXT = 'Нет прав на это действие. Обратитесь к руководителю';

/**
 * Страж прав сервера отвечает по-английски и называет право
 * («Missing capability BRIEFING_JOURNAL_READ …»): человеку такой текст ничего не
 * говорит. Отказ по правам (403) показывается общим образцом; прикладные отказы
 * с человеческим текстом остаются как есть.
 */
export function friendlyMessage(status: number, message: string): string {
  return status === 403 && /Missing capability|Forbidden resource|^Forbidden$/i.test(message) ? NO_RIGHTS_TEXT : message;
}
